import React, { useState } from 'react'
import { makeStyles, createStyles, Box, Card, fade, Divider, Button, Typography } from '@material-ui/core'
import { Link, useHistory } from 'react-router-dom'
// import Countdown from 'react-countdown'
// import getTime from 'date-fns/getTime'
// import isBefore from 'date-fns/isBefore'
// import parse from 'date-fns/parse'
import { ORDER_STATUS_HEADER } from 'src/mobile/utils/constant'
import {
  // PAY_EXPIRED_TIME,
  // DATABASE_DATE_TIMEZONE_TIME_FORMAT,
  ORDER_STATUS,
  // TIMEZONE,
  PACKAGE_INFO,
  DATE_FORMAT,
  SERVICE_PHONE_02,
  SITE_MATE_DATA,
  SERVICE_CHARGE_RATE,
} from 'src/utils/constant'
import EDialog from 'src/mobile/themes/components/EDialog'
// import OrderDialogContent from './OrderDialogContent'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
// import TagManager from 'react-gtm-module'
import { useDispatch } from 'react-redux'
// import { pay, cancelRefund, setOrderExpired } from 'src/store/slices/userSlice'
import { useTranslation } from 'react-i18next'
import isBefore from 'date-fns/isBefore'
import parse from 'date-fns/parse'
import { useCustomTranslation, useDateFnsLocale } from 'src/hooks'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'
import { ReactComponent as DoctorIcon } from 'src/mobile/assets/icons/doctor2.svg'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined'
import { ReactComponent as Refund } from 'src/mobile/assets/icons/refunded.svg'
import { ReactComponent as Refunding } from 'src/mobile/assets/icons/refunding.svg'
import { ReactComponent as Paid } from 'src/mobile/assets/icons/paid.svg'
import { ReactComponent as PendingPayment } from 'src/mobile/assets/icons/pending_payment.svg'
import { ReactComponent as FailRefund } from 'src/mobile/assets/icons/failed_refunded.svg'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { ReactComponent as MenuOrder } from 'src/mobile/assets/icons/menu_order.svg'
import { cancelRefund, applyRefund } from 'src/store/slices/userSlice'
// import OrderDialogContent from '../../components/Order/OrderDialogContent'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'
import { buttonClick } from 'src/utils/trackingCode'
const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      borderRadius: 6,
      margin: theme.spacing(2),
      paddingBottom: theme.spacing(1.5),
      border: '1px solid #E5E7EB',
      boxShadow: `0 3px 4px 0 ${fade(theme.palette.common.black, 0.04)}`,
    },
    doctorInfo: {
      border: 'none',
    },
    cardHeader: {
      padding: theme.spacing(1.5),
      boxShadow: `0 0.5px 0 0 ${theme.palette.grey[50]}`,
      background: '#F9FAFB',
      fontSize: 16,
      fontWeight: 500,
    },
    dot: {
      position: 'relative',
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderRadius: '50%',
      backgroundColor: fade(theme.palette.secondary.main, 0.2),
      marginRight: theme.spacing(0.5),
      '&:after': {
        content: '""',
        position: 'absolute',
        width: theme.spacing(0.5),
        height: theme.spacing(0.5),
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
      },
    },
    menu: {
      fontSize: theme.spacing(2),
      fontWeight: 600,
    },
    menuRed: {
      fontSize: theme.spacing(2),
      fontWeight: 600,
      color: '#D6334D',
    },
  }),
)

const OrderCard = ({ order, avatar, setOrderList }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const [tB] = useCustomTranslation()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const { formatDate } = useDateFnsLocale()

  const [drawerOpen, setEDrawerOpen] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleUpdateBooking = () => {
    setAnchorEl(null)
  }

  // const handlePay = async (e) => {
  //   if (order?.currency !== 'HKD') {
  //     TagManager.dataLayer({
  //       dataLayer: {
  //         ecommerce: null,
  //       },
  //     })
  //     TagManager.dataLayer({
  //       dataLayer: {
  //         event: 'checkout',
  //         ecommerce: {
  //           checkout: {
  //             actionField: { step: 2 },
  //             products: [
  //               {
  //                 name: order?.doctorName || '',
  //                 id: `${order?.doctorId || ''}`,
  //                 price: `${order?.price || ''}`,
  //                 brand: order?.testCenterName || '',
  //                 category: order?.doctorTitle || '',
  //                 variant: order?.appointmentTime || '',
  //                 dimension1: order?.appointmentDate || '',
  //                 quantity: 1,
  //               },
  //             ],
  //           },
  //         },
  //       },
  //     })
  //     await dispatch(pay({ orderNumber: order?.orderNumber }))
  //   } else {
  //     history.replace('/add-order/paying', {
  //       price: order?.price,
  //       currency: order?.currency,
  //       orderNumber: order?.orderNumber,
  //       packages: order?.package,
  //     })
  //   }
  // }

  const handleCancelRefund = async () => {
    await dispatch(cancelRefund({ orderNumber: order?.orderNumber })).unwrap()
    setOrderList()
    setEDrawerOpen(false)
  }
  const handleRefund = async () => {
    buttonClick(
      'EH_MyAccount_Refund_ConfirmRefund',
      'EH_MyAccount_Refund_ConfirmRefund',
    )
    await dispatch(applyRefund({ orderNumber: order?.orderNumber })).unwrap()
    setOrderList()
  }

  const statusMark = (status) => {
    return (
      <Box
        alignItems="center"
        display="flex"
        color={
          status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED
            ? 'secondary.main'
            : status === ORDER_STATUS.PAID
            ? '#0CB458'
            : status === ORDER_STATUS.PENDING_PAYMENT
            ? '#CC9809'
            : 'grey.800'
        }
      >
        {t(ORDER_STATUS_HEADER?.[status]?.label)}
      </Box>
    )
  }

  // const countdownComplete = () => {
  //   dispatch(setOrderExpired({ orderNumber: order?.orderNumber }))
  // }

  // const cardFooter = (status) => {
  //   if (status === ORDER_STATUS.PENDING_REFUND || status === ORDER_STATUS.APPROVAL_SUCCEED)
  //     return (
  //       <Box mt={1.5} alignItems="center" justifyContent="space-between" display="flex">
  //         <Box color="secondary.main">{t('tips.refund_tips_list.1')}</Box>
  //         <EDialog
  //           loading
  //           title={t('are_you_sure.common', { action: '$t(glossary.cancel_refund)' })}
  //           trigger={
  //             <Button size="small" variant="contained" color="secondary">
  //               {t('glossary.cancel_refund')}
  //             </Button>
  //           }
  //           onConfirm={handleCancelRefund}
  //         >
  //           <OrderDialogContent orderInfo={order} />
  //         </EDialog>
  //       </Box>
  //     )
  //   if (status === ORDER_STATUS.PENDING_PAYMENT)
  //     return (
  //       <Box mt={1.5} alignItems="center" justifyContent="space-around" display="flex">
  //         <Countdown
  //           date={
  //             getTime(parse(order?.createTime + TIMEZONE, DATABASE_DATE_TIMEZONE_TIME_FORMAT, new Date())) +
  //             PAY_EXPIRED_TIME
  //           }
  //           onComplete={countdownComplete}
  //           autoStart
  //           renderer={({ hours, minutes, seconds, completed }) => {
  //             if (completed) {
  //               return (
  //                 <Box color="grey.900" component="span">
  //                   {t('glossary.appointment_time')}
  //                 </Box>
  //               )
  //             } else {
  //               // Render a countdown
  //               return (
  //                 <Typography variant="body2" color="secondary" noWrap>
  //                   <Box ml="58px" color="secondary.main" component="span">
  //                     {t('glossary.time_left_to_pay')}:{' '}
  //                     <Box component="span">
  //                       {`0${hours}`.slice(-2)}:{`0${minutes}`.slice(-2)}:{`0${seconds}`.slice(-2)}{' '}
  //                     </Box>
  //                   </Box>
  //                 </Typography>
  //               )
  //             }
  //           }}
  //         />
  //         <EDialog
  //           loading
  //           trigger={
  //             <Button size="small" variant="contained" color="secondary">
  //               {/* <ENumberFormat type="simple" value={order?.price} currency={order?.currency} /> */}
  //               <Box flexShrink={0} ml={0.5} component="span">
  //                 {t('glossary.go_to_pay')}
  //               </Box>
  //             </Button>
  //           }
  //           onConfirm={handlePay}
  //         >
  //           <OrderDialogContent orderInfo={order} />
  //         </EDialog>
  //       </Box>
  //     )
  //   return null
  // }

  return (
    <Card elevation={0} className={classes.card}>
      <Link to={`/${i18n.language}/profile/order/${order?.orderNumber}`}>
        <Box className={classes.cardHeader}>
          {' '}
          <Box justifyContent="space-between" alignItems="center" display="flex" color="grey.900">
            <Box>
              {t('glossary.order_id')}&nbsp;
              {order?.orderNumber}
            </Box>
            <Box display="flex" alignItems="center">
              <Box mr={1}> {statusMark(order.payStatus)}</Box>
              {order?.payStatus === ORDER_STATUS.PAID && <Paid />}
              {order?.payStatus === ORDER_STATUS.PENDING_PAYMENT && <PendingPayment />}
              {order?.payStatus === ORDER_STATUS.REFUNDED && <Refund />}
              {(order?.payStatus === ORDER_STATUS.REFUND_FAILED ||
                order?.payStatus === ORDER_STATUS.APPROVAL_FAILED) && <FailRefund />}
              {(order.payStatus === ORDER_STATUS.PENDING_REFUND ||
                order.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && <Refunding />}
            </Box>
          </Box>
          {(order.payStatus === ORDER_STATUS.PENDING_REFUND ||
            order.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && (
            <Box color="grey.400" fontSize={12} fontWeight={400}>
              {t('tips.refund_tips_list.1')}
            </Box>
          )}
        </Box>
        <Box>
          <Box fontSize={18} fontWeight={600} textAlign="center" my={2} color="#24252B">
            {t(PACKAGE_INFO[order?.package].title)}
          </Box>
          <Divider />
          <Box fontSize={16} fontWeight={500} color="#24252B" mx={4}>
            <Box display="flex" alignItems="center" my={2}>
              <LocationOnOutlinedIcon style={{ marginRight: '8px' }} />
              {order?.[tB('testCenterName')]}
            </Box>
            <Box display="flex" alignItems="center" justifyContent="flex-start" my={2}>
              <Box display="flex" alignItems="center" flexShrink={0} mr={3}>
                <DateRangeOutlinedIcon style={{ marginRight: '8px', flexShrink: 0 }} />
                {order?.appointmentDate}
              </Box>
              <Box display="flex" alignItems="center" flexShrink={0}>
                <AccessTimeIcon style={{ marginRight: '8px' }} />
                {order?.appointmentTime}
              </Box>
            </Box>
            <Box display="flex" justifyContent="flex-start" mb={2}>
              <Box display="flex" alignItems="center" width={180}>
                <DoctorIcon style={{ marginRight: '8px', flexShrink: 0 }} />
                {order?.[tB('doctorName')]}
              </Box>
              <Box display="flex" alignItems="center" width={180}>
                <PersonOutlinedIcon style={{ marginRight: '4px' }} />
                {order?.userName}
              </Box>
            </Box>
          </Box>
          <Divider />
        </Box>
      </Link>
      {/* {cardFooter(order?.payStatus)} */}
      <Box display="flex" mx={4} justifyContent="space-between" alignItems="center">
        <Box fontSize={16}>
          {order?.payStatus === ORDER_STATUS.PENDING_PAYMENT ? (
            <Box fontSize={16} color="#9CA3AF" mt={1}>
              {t('common.still_not_finish')}
            </Box>
          ) : (
            <ENumberFormat type="simple" value={order?.payPrice} currency={order?.currency} />
          )}
        </Box>
        {order?.payStatus !== ORDER_STATUS.PENDING_PAYMENT &&
        order?.payStatus !== ORDER_STATUS.REFUNDED &&
        order?.payStatus !== ORDER_STATUS.REFUND_FAILED &&
        order?.payStatus !== ORDER_STATUS.APPROVAL_FAILED ? (
          <Box>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MenuOrder />
            </IconButton>

            <Menu id="long-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleUpdateBooking}>
              {order?.payStatus === ORDER_STATUS.PAID && (
                <MenuItem className={classes.menu} onClick={() => setAnchorEl(null)}>
                  <EDialog
                    loading
                    updateBooking={true}
                    title={t('common.update_booking')}
                    trigger={<Button>{t('common.update_booking')}</Button>}
                    onConfirm={() => {
                      window.location.href =
                        i18n.language === 'zh-HK'
                          ? SITE_MATE_DATA.WHATSAPP_UPDATE_HK
                          : i18n.language === 'en'
                          ? SITE_MATE_DATA.WHATSAPP_UPDATE_EN
                          : SITE_MATE_DATA.WHATSAPP_UPDATE_CN
                    }}
                  >
                    <Box my={2}> {t('common.update_booking_tips', { field: SERVICE_PHONE_02 })}</Box>
                  </EDialog>
                </MenuItem>
              )}
              {order?.payStatus === ORDER_STATUS.PAID &&
                isBefore(new Date(), parse(order?.appointmentDate, DATE_FORMAT, new Date())) && (
                  <MenuItem onClick={handleClose} className={classes.menuRed}>
                    <Button style={{ color: '#D6334D' }} onClick={() => setEDrawerOpen(true)}>
                      {t('glossary.apply_refund')}
                    </Button>

                    <EDrawer
                      onClose={() => setEDrawerOpen(false)}
                      open={drawerOpen}
                      title={t('glossary.apply_refund')}
                    >
                      <Divider />
                      <Box color="grey.900" my={2} lineHeight={1.5}>
                        {t('common.refund_tips')}
                      </Box>
                      <Divider />
                      <Box fontSize={16} fontWeight={600} lineHeight={2}>
                        {t('glossary.pay_amount')}
                      </Box>{' '}
                      <ENumberFormat
                        color="grey.400"
                        // type="simple"
                        value={order?.payPrice}
                        currency={order?.currency}
                      />
                      <Box fontSize={16} fontWeight={600} lineHeight={2} mt={1.5}>
                        {t('glossary.refund_amount')}
                      </Box>
                      <ENumberFormat
                        color="grey.400"
                        value={
                          order.payMethod === 'Atome'
                            ? order.payPrice
                            : order?.payPrice *
                              (1 - (order?.refundOrigin || order.payStatus === 1 ? SERVICE_CHARGE_RATE : 0))
                        }
                        currency={order?.currency}
                      />
                      <Divider style={{ marginTop: '16px' }} />
                      <Box display="flex" my={1} justifyContent="space-between">
                        <Box className={classes.column} flexShrink="0">
                          <Typography className={classes.heading}>{t('glossary.order_id')}</Typography>
                        </Box>
                        <Box>
                          <Typography className={classes.secondaryHeading}>{order?.orderNumber}</Typography>
                        </Box>
                      </Box>
                      <Divider />
                      <Box mt={2}>
                        <Box fontSize={18} fontWeight={700}>
                          {t(PACKAGE_INFO[order?.package].title)}
                        </Box>
                      </Box>
                      <Box display="flex" alignItems="center" my={1}>
                        <LocationOnOutlinedIcon variant="outline" style={{ fontSize: 16, marginRight: 4 }} />
                        <Box component="span" fontSize={16} fontWeight={700}>
                          {order?.[tB('testCenterName')]}
                        </Box>
                      </Box>{' '}
                      <Box fontSize={14} ml={2.5} mb={2} color="#4B5563">
                        {order?.[tB('testCenterAddress')]}
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <DateRangeOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('common.booking_date')}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {formatDate(new Date(order?.appointmentDate))}
                        </Box>
                      </Box>
                      <Divider />
                      <Box
                        component="span"
                        display="flex"
                        alignItems="center"
                        my={2}
                        justifyContent="space-between"
                      >
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <AccessTimeIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('glossary.appointment_time')}
                        </Box>
                        <Box fontSize={14}> {order?.appointmentTime}</Box>
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between">
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <DoctorIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('glossary.doctor')}
                        </Box>
                        <Box component="span" fontSize={14} fontWeight={700}>
                          {order?.[tB('doctorName')] || ''}
                        </Box>
                      </Box>
                      <Divider />
                      <Box display="flex" alignItems="center" my={2} justifyContent="space-between" pb={1}>
                        <Box display="flex" alignItems="center" fontWeight={600} fontSize={14}>
                          <PersonOutlineOutlinedIcon variant="outline" style={{ marginRight: 4 }} />
                          {t('common.tester')}
                        </Box>
                        <Box component="span" fontSize={14}>
                          {order?.userName}
                        </Box>{' '}
                      </Box>{' '}
                      <EDialog
                        loading
                        noAction={true}
                        title={t('common.refund_rules')}
                        trigger={
                          <Box mb={2} style={{ textDecorationLine: 'underline' }}>
                            {t('common.refund_notice')}
                          </Box>
                        }
                      >
                        <Box my={1} lineHeight={1.5} fontSize={16}>
                          {' '}
                          {t('common.refund_detail_rules')}
                        </Box>
                      </EDialog>
                      <Button onClick={handleRefund} style={{ background: '#D6334D', color: '#fff' }}>
                        {t('common.confirm_refund')}
                      </Button>
                      <Button
                        onClick={() => setEDrawerOpen(false)}
                        variant="outlined"
                        style={{ marginTop: '8px' }}
                      >
                        {t('common.cancel')}
                      </Button>
                    </EDrawer>
                  </MenuItem>
                  // <MenuItem onClick={handleClose} className={classes.menuRed}>
                  //   <EDialog
                  //     loading
                  //     title={t('are_you_sure.common', {
                  //       action: '$t(common.apply)',
                  //       field: '$t(common.refund)',
                  //     })}
                  //     trigger={}
                  //     onConfirm={handleRefund}
                  //   >
                  //
                  //   </EDialog>
                  // </MenuItem>
                )}
              {(order?.payStatus === ORDER_STATUS.PENDING_REFUND ||
                order?.payStatus === ORDER_STATUS.APPROVAL_SUCCEED) && (
                <MenuItem onClick={handleClose} className={classes.menu}>
                  <EDialog
                    loading
                    title={t('are_you_sure.common', { action: '$t(glossary.cancel_refund)' })}
                    trigger={<Button>{t('glossary.cancel_refund')}</Button>}
                    onConfirm={handleCancelRefund}
                  />
                </MenuItem>
              )}
            </Menu>
          </Box>
        ) : order?.payStatus === ORDER_STATUS.REFUNDED ||
          order?.payStatus === ORDER_STATUS.REFUND_FAILED ||
          order?.payStatus === ORDER_STATUS.APPROVAL_FAILED ? null : (
          <Button
            style={{
              background: '#FEEEEA',
              fontSize: '16px',
              fontWeight: 600,
              color: '#F2512D',
              marginTop: '8px',
            }}
            onClick={() => {
              history.push(`/${i18n.language}/add-order/paying/`, {
                price: order.price,
                currency: order.currency,
                orderNumber: order.orderNumber,
                packages: order?.package,
                from: 'list',
              })
            }}
          >
            {t('common.pay_it')}
          </Button>
        )}
      </Box>
    </Card>
  )
}

export default OrderCard
